import { isLogtoRequestError, LogtoError, LogtoRequestError } from '@logto/js';

const createRequester = (fetchFunction) => {
    return async (...args) => {
        const response = await fetchFunction(...args);
        if (!response.ok) {
            const responseJson = await response.json();
            if (!isLogtoRequestError(responseJson)) {
                throw new LogtoError('unexpected_response_error', responseJson);
            }
            // Expected request error from server
            const { code, message } = responseJson;
            throw new LogtoRequestError(code, message);
        }
        return response.json();
    };
};

export { createRequester };
